/** Color según qué tan cerca está una bolsa de agotarse. Compartido entre
 * `BagStatusCard` (la tarjeta grande) y `NameDropdown` (la bolita del
 * avatar), para que el mismo % siempre se vea del mismo color en toda la
 * app. */
/** Título de una bolsa: las personalizadas usan su nombre (puede haber varias). */
export function bagDisplayLabel(bag, metricLabels = {}) {
  if (bag?.metric === 'custom' && bag.name) return bag.name;
  return metricLabels[bag?.metric] ?? bag?.metric;
}

export function progressColor(percent) {
  if (percent >= 100) return '#f5222d';
  if (percent >= 85) return '#faad14';
  return '#fa8c16';
}
